import { createAction, handleActions } from 'redux-actions'
import client from 'common/util/http'
import cache from 'common/util/cache'
import { replace, push } from 'react-router-redux'
import { loadStart, loadFinish, loadError } from 'common/redux/root'

const RESET = 'referral_opt_out/RESET'
const LOAD = 'referral_opt_out/LOAD'

const load = createAction(LOAD)
const reset = createAction(RESET)

const defaultErrorHandler = dispatch => error => {
  dispatch(loadError(error))
  return Promise.reject(error)
}

const defaultLoadHandler = dispatch => response => {
  dispatch(load(response))
  dispatch(loadFinish())
  return Promise.resolve(response)
}

export function clearValidation() {
  return dispatch => {
    dispatch(load({validationAttempted:false}))
  }
}

export function updateValidationAttempted(validCompany, validEmail, validReasons) {
  return dispatch => {
    dispatch(load({
      validCompany,
      validEmail,
      validReasons,
      validationAttempted: true
    }))
  }
}

export function submitReferralOptOut(hash, type, company, officer, refer, email, phone, reasons, feedback) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('submit_opt_out', {
      data: {
        hash,
        type,
        company,
        officer,
        refer,
        email,
        phone,
        reasons,
        feedback,
      }
    })
    .then(() => {
      dispatch(replace({pathname: `/referral/${hash}`, state: {}}))
      dispatch(loadFinish())
    })
    .catch(dispatch(defaultErrorHandler))
    .finally(() => {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage('dismiss-modal')
      }
    })
  }
}

export function deleteOptOut(hash, type) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('delete_opt_out', {
      data: {
        hash,
        type
      }
    })
    .then(() => {
      dispatch(replace({pathname: `/referral/${hash}`, state: {}}))
      dispatch(loadFinish())
    })
    .finally(() => {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage('dismiss-modal')
      }
    })
  }
}

export function resetReferralOptOut(company, officer, refer, email, phone, reasons, feedback) {
  return dispatch => {
    dispatch(reset())
    dispatch(load({
      company,
      officer,
      refer,
      email,
      phone,
      reasons,
      feedback
    }))
  }
}

export function updateCompany(company) {
  return dispatch => {
    dispatch(load({
      company,
      validCompany: true
    }))
  }
}

export function updateOfficer(officer) {
  return dispatch => {
    dispatch(load({
      officer
    }))
  }
}

export function updateRefer(refer) {
  return dispatch => {
    dispatch(load({
      refer
    }))
  }
}

export function updateEmail(email) {
  return dispatch => {
    dispatch(load({
      email,
      validEmail: true
    }))
  }
}

export function updatePhone(phone) {
  return dispatch => {
    dispatch(load({
      phone
    }))
  }
}

export function updateReasons(reasons) {
  return dispatch => {
    dispatch(load({
      reasons,
      validReasons: true
    }))
  }
}

export function updateFeedback(feedback) {
  return dispatch => {
    dispatch(load({
      feedback
    }))
  }
}

const initialState = {
  validationAttempted: false
}

export default handleActions({
  [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
  [RESET]: (state, { payload }) => ({ ...initialState }),
}, initialState)
